import React, { useEffect } from 'react';
import { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/outline';
import { XIcon } from '@heroicons/react/solid';
import {
  AiOutlineCheckCircle,
  AiOutlineExclamationCircle,
  AiOutlineWarning,
  AiOutlineMinusCircle,
} from 'react-icons/ai';
import {Enum_Notification} from "../../../typescript/enum"

export type Props = {
  type: string
  heading: string;
  subHeading?: string;
  showNotification: React.Dispatch<React.SetStateAction<boolean>>
}

export const Notification: React.FC<Props> = ({heading, subHeading, type,showNotification}) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      showNotification(false)
    }, 4000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const notificationType = () => {
    switch (type) {
      case Enum_Notification.success:
        return <AiOutlineCheckCircle className="h-6 w-6 text-green-400" />;
      case Enum_Notification.error:
        return <AiOutlineExclamationCircle className="h-6 w-6 text-red-500" />;
      case Enum_Notification.warning:
        return <AiOutlineWarning className="h-6 w-6 text-yellow-700" />;
      case Enum_Notification.neutral:
        return <AiOutlineMinusCircle className="h-6 w-6 text-gray-400" />;
  
      default:
        break;
    }
  }

  return (
    <>
      {/* Global notification live region, render this permanently at the end of the document */}
      <div
        aria-live="assertive"
        className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
      >
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    {notificationType()}
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">
                      {heading}
                    </p>
                    {subHeading && (
                      <p className="mt-1 text-sm text-gray-500">{subHeading}</p>
                    )}
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button
                      className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => {
                        setShow(false); //dispatch close notification action
                      }}
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
};
